export default __webpack_public_path__ + "static/media/ind1.0da3309e.svg";